<template>
    <div class="cancel-confirmation-wrapper">
      <p class="cancel-confirmation-message">{{ cancelMessage }}</p>
      <button @click="confirmCancellation" class="cancel-confirm-button">Confirm Cancellation</button>
    </div>
  </template>
  
  <script>
  import { ref } from 'vue';
  import { useStore } from 'vuex';
  
  export default {
    props: {
      purchaseId: {
        type: String,
        required: true
      }
    },
    setup(props) {
      const store = useStore();
      const cancelMessage = ref('');
  
      const confirmCancellation = async () => {
        const userId = store.state.user.id;
        const response = await store.dispatch('offers/confirmCancellation', {
          userId,
          purchaseId: props.purchaseId
        });
        cancelMessage.value = response.message;
      };
  
      return { confirmCancellation, cancelMessage };
    }
  }
  </script>

<style scoped>
/* =========================================================================
   APPLICATION MOBILE (iOS / Android) — préfixé body.is-native, donc inerte
   sur le site web.

   Le bloc précédent stylait `body.is-native button`, c'est-à-dire TOUS les
   boutons de l'application depuis ce composant. Les règles sont désormais
   ciblées sur ses propres éléments.

   Confirmer une annulation est l'action destructrice finale : fond
   --oc-danger, jamais le rouge de marque, qui signale les actions positives.
   ========================================================================= */

body.is-native .cancel-confirmation-wrapper {
  width: 100%;
  box-sizing: border-box;
  padding: var(--oc-sp-4);
  background: var(--oc-surface);
  border-radius: var(--oc-r-lg);
  box-shadow: var(--oc-e1);
}

body.is-native .cancel-confirmation-message {
  margin: 0;
  font-family: var(--oc-font-text);
  font-size: var(--oc-text-base);
  line-height: 1.45;
  color: var(--oc-ink-2);
}

body.is-native .cancel-confirmation-message:empty {
  display: none;
}

body.is-native .cancel-confirm-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: var(--oc-tap);
  margin-top: var(--oc-sp-3);
  padding: 0 var(--oc-sp-5);
  font-family: var(--oc-font-text);
  font-size: var(--oc-text-base);
  font-weight: 700;
  letter-spacing: 0.2px;
  color: #FFFFFF;
  background: var(--oc-danger);
  border: 0;
  border-radius: var(--oc-r-full);
  box-shadow: var(--oc-e1);
  box-sizing: border-box;
  cursor: pointer;
  transition: opacity var(--oc-fast) var(--oc-ease),
              transform var(--oc-fast) var(--oc-ease);
}

body.is-native .cancel-confirm-button:active {
  opacity: 0.88;
  transform: scale(0.975);
}
</style>
